(function (){
    'use strict';



    var extDeps = ['angularMoment'];
    var module = angular.module('app.common.services',extDeps);




    //-------------------





    /**
     * Service that returns user related information
     */
    module.factory('userService', userService);
    userService.$inject = ['$q','$window','lodash'];
    function userService($q,$window, lodash){
        return {
            getUserAsync: _getUserAsync
        };

        function _getUserAsync(){

            var promises = [
                _getUserDisplayTitleAsync()
                , _getUserPermissionsAsync()
                , _getUsernameAsync()
            ];

            return $q.all(promises)
                .then(function(results){

                    var rt = {
                        displayTitle: results[0]
                        , permissions: results[1]
                        , username: results[2]
                    };
                    return $q.resolve(rt);
                });
        }

        function _getUserDisplayTitleAsync(){
            return $q.resolve($window.sessionStorage.userDisplayTitle);
        }

        function _getUsernameAsync(){
            return _getUserContextAsync()
                .then(function(result){
                    return result.UserName;
                });
        }

        function _getUserContextAsync(){
            var value = $window.sessionStorage.userContextJson
                ? angular.fromJson($window.sessionStorage.userContextJson)
                : {};

            return $q.resolve(value);
        }

        function _getUserPermissionsAsync(){
            if(_getUserPermissionsAsync.cache)
                return $q.resolve(_getUserPermissionsAsync.cache);

            return _getUserContextAsync()
                .then(function(results){
                    return lodash.chain(results.Permission || results.permission)
                        .mapValues(function(value,key){
                            return {key:key, value:value};
                        })
                        .map(function(x){
                            return { key:x.key, value:x.value };
                        })
                        .value();

                }).then(function(results){
                    var rt = {
                        profile : {}
                        , rdo : {}
                        , leave : {}
                        , payslips: {}
                        , roster: {}
                        , payableTime: {}
                        , timesheets: {}
                    };
                    results.forEach(function(x){
                        _convertFunctionToPermission(x,rt);
                    });

                    _getUserPermissionsAsync.cache = rt;
                    return _getUserPermissionsAsync();
                });
        }

        function _convertFunctionToPermission(kvPair, target){
            var group;

            if(kvPair.key.match(/^profile/i))
                group = target.profile;
            else if(kvPair.key.match(/^leaveRoster/i))
                group = target.rdo;
            else if(kvPair.key.match(/^leave/i))
                group = target.leave;
            else if(kvPair.key.match(/^payslip/i))
                group = target.payslips;
            else if(kvPair.key.match(/^roster/i))
                group = target.roster;
            else if(kvPair.key.match(/^payableTime/i))
                group = target.payableTime;
            else if(kvPair.key.match(/^timesheets/i))
                group = target.timesheets;
            

            if(!group)
                return;

            var permissionKey= kvPair.key.replace(/^(LeaveRoster|LeaveApplication|Leave|Roster|Payslip|Profile|PayableTime|Timesheets)/,'');
            //if(permissionKey === 'View')
            //    return;

            group[permissionKey] = kvPair.value;
        }
    }




    //-------------------




    module.factory('calendarEventsService', calendarEventsService);
    calendarEventsService.$inject = ['$q', 'moment', 'calendarService', 'RostersApi','NotesApi','calendarEventsCache'];
    function calendarEventsService($q, moment, calendarService, RostersApi, NotesApi, calendarEventsCache){

        var ViewTypes = { Shifts:'Shifts', FatigueScores:'FatigueScores', Rdo:'Rdo', RdoRequestCalendar:'RdoRequestCalendar', LeaveCalendar:'LeaveCalendar' };
        return {
            getEventsInMonthAsync: getEventsInMonthAsync
            , ViewTypes: ViewTypes
        };


        function getEventsInMonthAsync(momentDate, groupByWeek, viewType, extraParams){

            momentDate= momentDate.clone();

            // return values from cache if already built
            var key = momentDate.format('MMYYYY') + (groupByWeek || '') + JSON.stringify(extraParams);

            var cachedResult = calendarEventsCache.get(key);
            if(cachedResult)
                return prepareCalendarForViewAsync(cachedResult,viewType);

            var weekStartsOnSunday = true;
            var promises = [
                getRosterRecordsAsync(momentDate,extraParams)
                , getNotesAsync(momentDate)
                , calendarService.getWeekListForMonthAsync(momentDate, weekStartsOnSunday)
            ];


            // make extra calls for performance improvement
             getRosterRecordsAsync(momentDate.clone().add(1,'months'),extraParams);
             getRosterRecordsAsync(momentDate.clone().add(2,'months'),extraParams);

            return $q.all(promises)
                .then(function(results){
                    return mergeRosterRecordsAndNotesWithCalendarAsync(results[0], results[1], results[2]);
                }).then(function(results){

                    // cache results because the merge operation is expensive
                    calendarEventsCache.put(key, groupByWeek ? results : results.getAllDays());
                    return getEventsInMonthAsync(momentDate, groupByWeek, viewType, extraParams);
                });
        }


         function prepareCalendarForViewAsync(calendarDays, viewType){
             var rt = angular.copy(calendarDays);
             rt.forEach(function(day){
                 switch (viewType){
                     case ViewTypes.FatigueScores:
                         day.content = day.fatigueContent;
                         if(day.shiftsCount > 1)
                             day.content = 'View details';
                         break;
                     case ViewTypes.Rdo:
                     case ViewTypes.RdoRequestCalendar:
                         if(day.hasRdoRequest)
                            day.content = 'RDO Request';
                         else if(day.hasOffShift)
                            day.content = day.shiftContent;
                         else
                            day.content = '';
                         break;
                     case ViewTypes.LeaveCalendar:
                         day.content = day.shiftContent;
                         if(day.shiftsCount > 1)
                             day.content = day.shiftsCount + ' shifts';
                         break;
                     default:
                         day.content = day.shiftContent;
                         if(day.shiftsCount > 1)
                             day.content = 'View details';
                         break;
                 }

                 // Modify the content according on the leave status and view type
                 if(day.hasLeave){
                     if(day.hasRejectedLeave && !day.hasApprovedLeave) {
                         if (viewType === ViewTypes.LeaveCalendar)
                             day.content = '';
                         else
                             for(var i=day.customStyles.length; i >=0; i--)
                                if((/leave/i).test(day.customStyles[i]))
                                    day.customStyles[i]='';
                     }
                     else
                         day.content = '';
                 }

                 // Remove RDO styles from the Shift Roster View
                 if(day.hasRdoRequest) {
                     if (viewType === ViewTypes.Shifts)
                         for(var i=day.customStyles.length; i >=0; i--)
                             if((/rdo/i).test(day.customStyles[i]))
                                 day.customStyles[i]='';
                 }

                 // Remove Note styles from the Leave Calendar View
                 if(day.noteData) {
                     if (viewType === ViewTypes.LeaveCalendar)
                         for(var i=day.customStyles.length; i >=0; i--)
                             if((/note/i).test(day.customStyles[i]))
                                 day.customStyles[i]='';
                 }

                 // Remove Note styles from the RDO request calendar View
                 if (day.noteData) {
                     if (viewType === ViewTypes.RdoRequestCalendar || viewType === ViewTypes.Rdo)
                         for (var i = day.customStyles.length; i >= 0; i--)
                             if ((/note/i).test(day.customStyles[i]))
                                 day.customStyles[i] = '';
                 }


             });
             return $q.resolve(rt);
        }

        function mergeRosterRecordsAndNotesWithCalendarAsync(rosterData, notes, calendar) {

            // expands weeks with rosterData
            rosterData.forEach(function(x){ createDayEventInCalendar(calendar ,x); });

            // expands weeks with note data
            notes.forEach(function(x){ createNoteInCalendar(calendar, x); });

            // appends any summary data to day objects
            calendar.getAllDays().forEach(function(x){ prepareCustomStylingForCalendarDay(x); });

            return calendar;

            //---

            function createDayEventInCalendar(cal, record){

                var eventForCalendar = {
                     type : ''
                    , subType : ''
                    , startTime : record.startTime ? moment(record.startTime,'HH:mm:ss') : null
                    , endTime : record.endTime ? moment(record.endTime,'HH:mm:ss') : null
                    , description : record.itemDescription
                    , shortDescription: record.itemShortDescription
                    , duration: parseFloat(record.duration) || 0
                    , fatigue: parseFloat(record.fatigue) || 0
                    , dutyCycleHours: parseFloat(record.dutyCycleHours) || 0
                    , isHoliday: record.itemTypeId === 'PublicHoliday'
                    , isOffShift : false
                };


                var startDate = moment(new Date(record.startDate)).hours(1)
                    , endDate = moment(new Date(record.endDate)).hours(1);

                switch(record.itemTypeId){
                    case 'Leave' :
                        eventForCalendar.type= 'leave';
                        if(record.leaveStatus)
                            eventForCalendar.subType = 'leave-' + record.leaveStatus.toLowerCase();
                        if((/rejected|voided|denied/i).test(record.leaveStatus))
                            eventForCalendar.isRejected = true;
                        else if((/approved/i).test(record.leaveStatus))
                            eventForCalendar.isApproved = true;
                        break;
                    case 'Roster':
                        eventForCalendar.type= 'roster-detail';

                        if(record.itemSubTypeId){
                            eventForCalendar.subType = record.itemSubTypeId;
                        }else{
                            switch(record.shiftCategory){
                                case 'OffShift': eventForCalendar.subType = 'day-offshift';break;
                                case 'OffAvail': eventForCalendar.subType = 'day-offavail';break;
                                default:
                                    eventForCalendar.subType = 'day-shift'; //eventForCalendar.subType= eventForCalendar.duration > 0.1 ? 'day-shift' : '';
                                    break;
                            }
                        }

                        // if offshift just override subtype
                        if(record.offShift){
                            eventForCalendar.isOffShift = true;
                            eventForCalendar.subType = 'day-offshift';
                        }

                        eventForCalendar.shiftData = record.shiftData || {};

                        // aggregates total shift hours for the week
                        var week = cal.getWeekAt(startDate);
                        if(week)
                            week.totalShiftHours = (week.totalShiftHours || 0) + eventForCalendar.duration;

                        break;
                    case 'Availability':
                        eventForCalendar.type = 'availability';
                        eventForCalendar.subType = (record.itemSubTypeId || '').toLowerCase();
                        break;
                    case 'RosterChanges':

                        // must be moved to the server
                        if((/approved/i).test(record.itemDescription))
                            record.status = 'approved';
                        else if((/rejected|voided|denied/i).test(record.itemDescription))
                            record.status = 'non-approved';
                        else if((/submitted/i).test(record.itemDescription))
                            record.status = 'pending';
                        else
                            record.status = '';

                        eventForCalendar.isRdoRequest = true;
                        eventForCalendar.type = 'rdo-request';
                        eventForCalendar.subType = 'rdo rdo-request-' + (record.status || '').toLowerCase();

                        break;
                }

                // maps the eventInDay to calendar day objects while also decorating it with new properties
                var cursorDate = startDate.clone();
                while(endDate.diff(cursorDate,'days') >= 0){
                    var day = cal.getDayAt(cursorDate);
                    if(day){
                        if(eventForCalendar.type === 'availability' && eventForCalendar.subType === 'unavailable')
                            day.cannotHostLeaveRequest = true;
                        else if(eventForCalendar.isOffShift)
                            day.hasOffShift = true;
                        else if(eventForCalendar.isRdoRequest){
                            day.hasRdoRequest = true;
                            if(eventForCalendar.isApproved)
                                day.hasApprovedRdoRequest = true;
                        }
                        else if(eventForCalendar.isHoliday)
                            day.isHoliday = true;
                        else if(eventForCalendar.type === 'leave'){
                            day.hasLeave = true;
                            if(eventForCalendar.isRejected)
                                day.hasRejectedLeave = eventForCalendar.isRejected;
                            if(eventForCalendar.isApproved)
                                day.hasApprovedLeave = eventForCalendar.isApproved;
                        }
                        else if(eventForCalendar.type === 'roster-detail' && !eventForCalendar.isOffShift ){
                            // count number of shifts on day
                            if(!day.shiftsCount) day.shiftsCount = 0;
                            day.shiftsCount++;
                        }

                        day.events.push(eventForCalendar);
                    }

                    cursorDate.add(25,'hours').hours(1); // momentjs had a twitch with daylight savings and was moving 23 hours fwd with add days

                    // when entry is a roster, only consider the date start
                    if(eventForCalendar.type == 'roster-detail')
                        return;
                }

            }

            function createNoteInCalendar(cal, note){
                var day = cal.getDayAt(note.associatedDate);
                if(day)
                    day.noteData = note;
            }

            function prepareCustomStylingForCalendarDay(day){
                day.customStyles = [];

                // if the day has a Note
                if(day.noteData)
                    day.customStyles.push('note');

                if(day.isHoliday)
                    day.customStyles.push('day-holiday');


                // push styles in from events
                day.events.forEach(function(x){
                    day.customStyles.push(x.type);
                    day.customStyles.push(x.subType);

                    if(day.shiftContent === undefined && x.type === 'roster-detail') {
                        day.shiftContent = x.shortDescription;
                        day.fatigueContent = x.fatigue;
                    }

                    if(day.shiftsCount > 1)
                        day.customStyles.push('alert-view-details');
                });
            }

        }

        function getRosterRecordsAsync(momentDate, params){

            var firstOfMonth = momentDate.date(1);

            var payload = {
                startDate:firstOfMonth.clone().day(0).format('YYYY-MM-DD')
                , endDate:firstOfMonth.clone().add(1,'months').day(6).format('YYYY-MM-DD')
            };
            if(params)
                angular.extend(payload, params);

            return RostersApi.query(payload)
                .$promise;
        }


        function getNotesAsync(momentDate){

            var firstOfMonth = momentDate.date(1);

            var payload = {
                startDate:firstOfMonth.clone().day(0).format('YYYY-MM-DD')
                , endDate:firstOfMonth.clone().add(1,'months').day(6).format('YYYY-MM-DD')
            };

            return NotesApi.query(payload).$promise;
        }


    }




    /**
     * Roster cache
     */
    module.provider('calendarEventsCache', calendarEventsCacheProvider);
    calendarEventsCacheProvider.$inject = [];
    function calendarEventsCacheProvider() {

        resolver.$inject=['$injector'];
        function resolver($injector) {
            var $cacheFactory = $injector.get('$cacheFactory');
            return $cacheFactory('calendarEventsCache');
        }

        return {
            $get: resolver
        };
    }



})();

